import { HistoryEvent } from "./tactics.model";
export class KillerPlayer {
    constructor(name, number) {
        this.kHit = false;
        this.iHit = false;
        this.l1Hit = false;
        this.l2Hit = false;
        this.eHit = false;
        this.rHit = false;
        this.name = name;
        this.number = number;
        this.lives = 5;
    }
    isActiveKiller() {
        return this.kHit && this.iHit && this.l1Hit && this.l2Hit && this.eHit && this.rHit;
    }
}
export class KillerHistoryEvent extends HistoryEvent {
    constructor(type, playerIndex, characterHit, lives) {
        super(type, playerIndex, 0);
        this.characterHit = characterHit;
        this.lives = lives;
    }
}
